<!--
    描述：业务模板 新增 / 编辑页面
    时间：2020-05-19
    Created by ws
-->
<template>
	<div class="w-page-main">
		<div class="w-page-header bd-header">
			<div class="left-title text-overflow">
				<span>{{ curTitle }}页面内容</span>
			</div>

			<div class="btnGroups">
				<el-button type="success" size="small" @click="doSave">保存</el-button>
				<el-button type="primary" size="small" @click="backPage">返回</el-button>
				<el-button type="info" size="small">页面预览</el-button>
			</div>
		</div>
		<div class="w-page-container overflow-y pdb10">
			<!-- 项目结构  选择区块 -->
			<template v-if="curType === 2">
				<el-form label-width="120px" inline class="select-form" :model="pageObj">
					<el-form-item label="模板应用类型" class="list-form-item">
						<el-select size="small" class="width-150" v-model="pageObj.applyType">
							<el-option
								v-for="(item, index) in templateList"
									   :key="'project' + index"
									   :label="item.sname"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" class="list-form-item">
						<el-checkbox-group v-model="pageObj.applyRange">
							<el-checkbox v-for="(item, index) in templateCheckList" :key="'check' + index" :label="item.value">{{
								item.sname
							}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
			</template>

			<!-- 建设项目结构  选择区块 -->
			<template v-if="curType === 3">
				<el-form label-width="120px" inline class="select-form" :model="pageObj">
					<el-form-item label="模板应用类型" class="list-form-item">
						<el-select size="small" class="width-150" v-model="pageObj.applyType">
							<el-option
								v-for="(item, index) in templateList"
									   :key="'project' + index"
									   :label="item.sname"
								:value="item.value"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="" class="list-form-item">
						<el-checkbox-group v-model="pageObj.applyRange">
							<el-checkbox v-for="(item, index) in templateCheckList" :key="'check' + index" :label="item.value">{{
								item.sname
							}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
			</template>

			<!-- 指标分析 标题模块 -->
			<div class="title-item" v-if="curType === 4">
				<div class="left">
					<span class="left-title">标题</span>
					<el-checkbox-group v-model="titleList" class="inline-block">
						<el-checkbox v-for="(item, index) in zjjd" :key="'标题' + index" :label="item.value">{{ item.sname }}</el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="right">
					<el-button type="primary" size="small" @click="sortTitle">标题排序</el-button>
				</div>
			</div>

			<!-- 区块信息 -->
			<div class="block-item" v-for="(item, index) in pageObj.blockList" :key="'区块' + index">
				<div class="block-header">
					<div class="title text-overflow">{{ item.sname }}</div>
					<div class="btn-tools">
						<el-button type="text" icon="el-icon-plus" @click="addField(item.formList)">添加字段</el-button>
						<el-button type="text" icon="el-icon-delete" @click="delBlock(pageObj.blockList, index)">删除区块</el-button>
						<el-button type="text" icon="el-icon-top" v-if="index !== 0" @click="handleBlock(index, 'up')">区块上移</el-button>
						<el-button type="text" icon="el-icon-bottom" v-if="index !== pageObj.blockList.length - 1" @click="handleBlock(index, 'down')"
							>区块下移</el-button
						>
					</div>
				</div>
				<div class="block-content" ref="">
					<el-table :data="item.formList" border>
						<el-table-column type="index" lable="序号" align="center" width="80"></el-table-column>
						<el-table-column prop="title" label="页面元素名称" align="center" show-overflow-tooltip min-width="150"></el-table-column>
						<el-table-column
							prop="formTypeName"
										 label="输入值类型"
										 align="center"
										 show-overflow-tooltip
							min-width="120"
						></el-table-column>
						<el-table-column label="属性编辑" align="center" show-overflow-tooltip width="315">
							<template slot-scope="scope">
								<el-checkbox class="mr10" v-model="scope.row.isSelected" :true-label="1" :false-label="0">显示</el-checkbox>
								<el-checkbox class="mr10" v-model="scope.row.isEditable" :true-label="1" :false-label="0">可编辑</el-checkbox>
								<el-checkbox class="mr10" v-model="scope.row.isRequired" :true-label="1" :false-label="0">必填</el-checkbox>
								<el-checkbox v-model="scope.row.isLine" :true-label="1" :false-label="0">是否同行</el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center" show-overflow-tooltip width="130">
							<template slot-scope="scope">
								<el-button
									type="text"
										   size="small"
										   icon="el-icon-top"
										   v-if="scope.$index !== 0"
										   title="上移"
									@click="handleTool(scope.$index, item.formList, 'up')"
								></el-button>
								<el-button
									type="text"
										   size="small"
										   v-if="scope.$index !== item.formList.length - 1"
										   icon="el-icon-bottom"
										   title="下移"
									@click="handleTool(scope.$index, item.formList, 'down')"
								></el-button>
								<el-button
									type="text"
										   size="small"
										   icon="el-icon-delete"
										   title="删除"
									@click="handleTool(scope.$index, item.formList, 'delete')"
								></el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>

			<!-- 添加区块按钮 -->
			<div class="mt10">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="addBlock">添加区块</el-button>
			</div>
		</div>

		<!-- 新增弹窗 -->
		<el-dialog
			:visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :title="dialogObj.title"
				   @closed="onDialogClosed"
				   :close-on-click-modal="false"
			destory-on-close
		>
			<!-- 新增区块表单 -->
			<el-form ref="blockForm" v-if="dialogObj.type === 'block'" :model="blockForm" :rules="blockRules" class="pdl10 pdr10" label-width="100px">
				<el-form-item label="区块名称：" prop="blockType" class="mt10">
					<el-select v-model="blockForm.blockType">
						<el-option
							v-for="(item, index) in showBlockList"
								   :key="'基本信息区块' + index"
								   placeholder="请选择"
								   :label="item.sname"
							:value="item.value"
						></el-option>
					</el-select>
					<!-- <el-input v-model="blockForm.sname"
							  placeholder="请输入区块名称"></el-input> -->
				</el-form-item>
			</el-form>

			<!-- 新增字段表格 -->
			<add-field-table v-show="dialogObj.type === 'field'" ref="fieldTable" @onSubmit=""> </add-field-table>

			<!-- 标题排序 -->
			<div class="title-box" v-if="dialogObj.type === 'title'">
				<el-table :data="pageObj.headLine" border height="400px">
					<el-table-column type="index" lable="序号" align="center" width="80"></el-table-column>
					<el-table-column prop="sname" label="标题名称" align="center" show-overflow-tooltip min-width="150"></el-table-column>
					<el-table-column label="操作" align="center" show-overflow-tooltip width="130">
						<template slot-scope="scope">
							<el-button
								type="text"
									   size="small"
									   icon="el-icon-top"
									   v-if="scope.$index !== 0"
									   title="上移"
								@click="handleTool(scope.$index, pageObj.headLine, 'up')"
							></el-button>
							<el-button
								type="text"
									   size="small"
									   v-if="scope.$index !== pageObj.headLine.length - 1"
									   icon="el-icon-bottom"
									   title="下移"
								@click="handleTool(scope.$index, pageObj.headLine, 'down')"
							></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>

			<!-- 新增模板表单 -->
			<el-form ref="saveForm" v-if="dialogObj.type === 'template'" :model="pageObj" :rules="saveRules" class="pdl10 pdr10" label-width="100px">
				<el-form-item label="模板名称：" prop="sname" class="mt10">
					<el-input v-model="pageObj.sname" placeholder="请输入模板名称"></el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="text-center">
				<el-button size="small" type="primary" :loading="btnLoading" @click="doAdd">确定</el-button>
				<el-button size="small" @click="onDialogClosed">取消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { $deepCopy } from '@/utils/tools'
import addFieldTable from './addField'
import { saveAnalysisFormTemplate, getTemplateInfo, getTypeList, getNewTypeList } from '@/api/modules/analysis'
import { mapState } from 'vuex'

export default {
	components: {
		addFieldTable
	},
	data() {
		return {
			// 页面参数
			pageObj: {
				sname: '', // 模板名称
				type: '', // 模板类型
				headLine: [], // 主题
				applyType: '', // 模板类型
				applyTypeName: '', // 模板类型中文
				applyRange: [], // 模板类型复选框数组
				conditions: '', // 模板类型 中文拼接
				blockList: [] // 区块数组
			},
			dialogObj: {
				visible: false,
				width: '400px',
				type: '',
				title: ''
			},
			// 区块表单
			blockForm: {
				sname: '',
				blockType: ''
			},
			blockRules: {
				blockType: [
					{
						required: true,
						trigger: 'change',
						message: '请选择区块名称!'
					}
				]
			},
			// 保存表单
			saveRules: {
				sname: [{ required: true, message: '请填写模板名称!' }]
			},
			// 标题表单
			titleForm: {
				sname: ''
			},
			titleRules: {
				sname: [{ required: true, message: '请填写标题名称!' }]
			},
			// 添加字段临时（当前）对象数组
			curFieldList: [],
			// 根据不同类型 展示的 不同区块下拉选
			showBlockList: [],

			// 模板类型下拉选
			templateList: [],

			// 模板类型复选框
			templateCheckList: [],

			// 标题复选框数组
			titleList: [],
			// 按钮等待状态
			btnLoading: false,
			// 回显状态
			backStatus: false
		}
	},
	created() {
		// 基本信息区块下拉选
		if (this.curType === 1) {
			this.showBlockList = this.lsqkm
		}

		// 项目结构、指标分析 下拉选 --- 之后再调回显
		if (this.curType == 3) {
			this.getNewSelectedList()
		} else {
			this.getSelectedList()
		}
	},
	methods: {
		// 回显数据
		getInfo() {
			this.backStatus = true
			getTemplateInfo({ id: this.curTemplateId })
				.then((res) => {
					let fieldObj = {
						applyRange: { defaultVlaue: [] },
						conditions: { defaultVlaue: '' },
						headLine: { defaultVlaue: [] },
					}
					Object.keys(res.data).forEach((x) => {
						if (
							['applyRange', 'conditions', 'headLine'].includes(x)
						) {
							res.data[x] = !!res.data[x]
								? res.data[x]
								: fieldObj[x].defaultVlaue
						}
					})
					this.pageObj = res.data

					// 标题数组
					this.titleList = [...this.pageObj.headLine.map((x) => x.value)]

					setTimeout(() => {
						this.backStatus = false
					}, 1000)
				})
				.catch((err) => {
					setTimeout(() => {
						this.backStatus = false
					}, 1000)
				})
		},

		// 模板应用类型下拉选等 集合
		getSelectedList() {
			getTypeList({}).then((res) => {
				this.templateList = res.data

				// 页面回显
				if (this.curTemplateId && this.curTemplateId !== '') {
					this.getInfo()
				}
			})
		},

		// 建设项目结构模板下拉选
		getNewSelectedList() {
			getNewTypeList({}).then((res) => {
				this.templateList = res.data.applyTypes
				this.templateCheckList = res.data.singleTypes
				this.showBlockList = res.data.blocks

				// 页面回显
				if (this.curTemplateId && this.curTemplateId !== '') {
					this.getInfo()
				}
			})
		},

		// 操作栏点击
		handleTool(index, list, type) {
			let current = JSON.parse(JSON.stringify(list[index]))
			// 上一个
			let _prev = list[index - 1]

			// 下一个
			let _next = list[index + 1]

			switch (type) {
				case 'up':
					// 当前位置
					_prev.sort = index
					current.sort = index - 1

					this.$set(list, index - 1, current)
					this.$set(list, index, _prev)
					break
				case 'down':
					// 当前位置
					current.sort = index + 1
					_next.sort = index

					this.$set(list, index, _next)
					this.$set(list, index + 1, current)

					break
				case 'delete':
					// console.log(index)
					// console.log(current)
					list.splice(index, 1)
					break
			}
		},

		// 返回上页
		backPage() {
			this.$router.push({
				name: 'Business-template',
				query: {
					type: this.curType
				}
			})
		},

		// 页面预览
		doPreview() {},

		// 页面保存数据
		doSave() {
			this.dialogObj.visible = true
			this.dialogObj.title = '保存模板'
			this.dialogObj.type = 'template'
			this.dialogObj.width = '400px'
		},

		// 区块 上移、下移
		handleBlock(index, type) {
			let list = JSON.parse(JSON.stringify(this.pageObj.blockList))
			let current = list[index]

			// 上一个
			let _prev = list[index - 1]

			// 下一个
			let _next = list[index + 1]

			if (type === 'up') {
				_prev.sort = index
				current.sort = index - 1

				this.$set(this.pageObj.blockList, index - 1, current)
				this.$set(this.pageObj.blockList, index, _prev)
			} else {
				current.sort = index + 1
				_next.sort = index

				this.$set(this.pageObj.blockList, index, _next)
				this.$set(this.pageObj.blockList, index + 1, current)
			}
		},

		// 删除区块
		delBlock(list, index) {
			list.splice(index, 1)
		},

		// 添加区块
		addBlock() {
			this.dialogObj.visible = true
			this.dialogObj.title = '添加区块'
			this.dialogObj.type = 'block'
			this.dialogObj.width = '400px'
		},

		// 添加字段
		addField(list) {
			this.dialogObj.visible = true
			this.dialogObj.title = '添加字段'
			this.dialogObj.type = 'field'
			this.dialogObj.width = '550px'

			this.curFieldList = list
		},

		// 标题排序
		sortTitle() {
			if (this.pageObj.headLine.length > 0) {
				this.dialogObj.visible = true
				this.dialogObj.title = '标题排序'
				this.dialogObj.type = 'title'
				this.dialogObj.width = '500px'
			} else {
				this.$message.warning('请先选择要排序的 标题!')
			}
		},

		// 确认添加
		doAdd() {
			this.btnLoading = true

			switch (this.dialogObj.type) {
				// 区块保存
				case 'block':
					this.$refs.blockForm.validate((valid) => {
						if (valid) {
							let _sname = this.showBlockList.find((x) => x.value === this.blockForm.blockType).sname

							let obj = {
								sname: _sname,
								blockType: this.blockForm.blockType,
								aid: '',
								formList: []
							}
							this.pageObj.blockList.push(obj)

							// 区块排序
							this.pageObj.blockList.map((item, index) => {
								item.sort = index
							})

							// 关闭弹窗
							this.onDialogClosed()
						} else {
							this.$message.error('请填写区块名称！')
						}
					})
					break
				// 字段保存
				case 'field':
					let list = this.$refs.fieldTable.getSelectedData()

					if (list.length > 0) {
						list.forEach((x) => {
							x.isLine = 0
							let _index = this.curFieldList.findIndex((y) => y.fieldId === x.fieldId)
							_index === -1 ? this.curFieldList.push(x) : ''
						})
					}

					// 字段排序
					this.curFieldList.map((item, index) => {
						item.sort = index
					})

					// 关闭弹窗
					this.onDialogClosed()
					break
				// 标题保存
				case 'title':
					this.pageObj.headLine.map((item, index) => {
						item.sort = index
					})

					// 关闭弹窗
					this.onDialogClosed()
					break
				// 模板保存
				case 'template':
					let params = Object.assign({}, this.pageObj)

					let _name = params.applyTypeName ? params.applyTypeName + '/' : ''
					params.type = this.curType
					params.applyRange.map((x) => {
						let _item = this.templateCheckList.find((y) => y.value === x)
						_item ? (_name += _item.sname + '、') : ''
					})
					params.conditions = _name && _name.length > 0 ? _name.substring(0, _name.length - 1) : ''

					this.$refs.saveForm.validate((valid) => {
						if (valid) {
							saveAnalysisFormTemplate(params)
								.then((res) => {
									if (res.operationCode === 1) {
										this.$message.success('保存成功, 即将返回模板列表页面...')

										// 返回上页
										setTimeout(() => {
											this.onDialogClosed()
											this.backPage()
										}, 1000)
									}
								})
								.catch((err) => {})
						} else {
							this.$message.error('请填写模板名称！')
						}
					})
					break
			}

			setTimeout(() => {
				this.btnLoading = false
			}, 1500)
		},

		// dialog 关闭事件
		onDialogClosed() {
			this.dialogObj.visible = false
			this.dialogObj.title = ''
			this.dialogObj.type = ''
		}
	},
	computed: {
		// 当前类型 1 为六算基本信息  2 为项目结构  3为指标分析
		curType() {
			return parseInt(this.$route.query.type)
		},
		// 当前标题
		curTitle() {
			let title = ''
			switch (parseInt(this.curType)) {
				case 1:
					title = '六算基本信息 '
					break
				case 2:
					title = '项目结构 '
					break
				case 3:
					title = '建设项目结构 '
					break
				default:
					title = ''
			}
			return title
		},
		// 当前模板ID
		curTemplateId() {
			return this.$route.query.id
		},
		// 全部码表
		...mapState('dict', {
			lsqkm: (state) => state.lsqkm, // 六算基本信息区块下拉选
			zjjd: (state) => state.zjjd // 指标分析标题数组
		})
	},
	watch: {
		// 模板应用类型的变化
		'pageObj.applyType': {
			handler: function(val) {
				if (val !== '') {
					// 首先清空 目前选择的 --- 非回显情况下
					if (!this.backStatus) {
						this.pageObj.blockList = []
						this.pageObj.applyRange = []
						this.pageObj.applyTypeName = ''
						this.blockForm.blockType = ''
					}

					// 赋值
					let _item = this.templateList.find((x) => x.value === val)
					this.pageObj.applyTypeName = _item.sname || ''

					if (_item && this.curType == 2) {
						this.showBlockList = _item.blockList
						this.templateCheckList = _item.typeList
					}
				}
			},
			deep: true
		},

		// 标题数组
		titleList(arr) {
			this.pageObj.headLine = []

			arr.map((x) => {
				let _item = this.zjjd.find((y) => y.value === x)

				this.pageObj.headLine.push(_item)
			})
		}
	}
}
</script>

<style scoped lang="less">
.block-item {
	@topH: 40px;
	display: flex;
	flex-direction: column;
	margin-top: 10px;
	border: 1px solid #b9c1d8;

	.block-header {
		height: @topH;

		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 10px;

		.title {
			font-size: 16px;
		}

		.btn-tools {
			height: 100%;
		}
	}

	.block-content {
		flex: 1;
	}
}
/deep/ .el-dialog__body {
	padding: 0 !important;
}

.list-form-item {
	margin-bottom: 0 !important;
	margin-top: 10px;

	.width-150 {
		width: 150px;
	}
}

.title-item {
	padding: 6px 0;
	padding-right: 180px;
	position: relative;

	.left {
		overflow: hidden;
		overflow-x: auto;
		white-space: nowrap;
		margin-top: 3px;
	}

	.right {
		position: absolute;
		right: 0;
		top: 5px;
	}
	.inline-block {
		display: inline-block;
	}
	.left-title {
		display: inline-block;
		width: 120px;
		text-align: right;
		font-size: 14px;
		color: #606266;
		padding-right: 12px;
	}
}

.select-form {
	white-space: nowrap;
	overflow-y: hidden;
	overflow-x: auto;
}

.title-box {
	padding: 10px;
}
</style>
